import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
export function useMapsConfig() {
  const [cfg, setCfg] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/maps/config").then((r) => { cache = r.data; setCfg(r.data); })
      .catch(() => setCfg({ map_enabled: false, routing_enabled: false }));
  }, []);
  return cfg;
}
export const resetMapsConfig = () => { cache = null; };

export const fmtDuration = (s) => {
  if (s == null) return "—";
  const m = Math.round(s / 60);
  return m < 60 ? `${m} min` : `${Math.floor(m / 60)} h ${m % 60} min`;
};
export const fmtMiles = (m) => (m == null ? "—" : `${(m / 1609.34).toFixed(1)} mi`);
